import { Form, Input, InputNumber } from 'antd';
import FormLayoutGroup from 'components/ui/form-layout-group';
import FormSection from 'components/ui/form-section';
import { useTranslation } from 'react-i18next';

const ProgramRIConsiderations: React.FC = () => {
  const { t } = useTranslation();

  return (
    <FormSection
      title={t('claim.binderClaimsActions.programRIConsiderations.title')}
      collapsible
    >
      <FormLayoutGroup mdColumns={2}>
        <Form.Item
          name="programCessionDeclarationName"
          label={t(
            'claim.binderClaimsActions.programRIConsiderations.programCessionDeclarationName'
          )}
        >
          <Input
            size="large"
            placeholder={t('general.enter', {
              field: t(
                'claim.binderClaimsActions.programRIConsiderations.programCessionDeclarationName'
              ),
            })}
          />
        </Form.Item>

        <Form.Item
          name="programCession"
          label={t(
            'claim.binderClaimsActions.programRIConsiderations.programCession'
          )}
        >
          <InputNumber
            size="large"
            className="w-full"
            suffix="%"
            placeholder={t('general.enter', {
              field: t(
                'claim.binderClaimsActions.programRIConsiderations.programCession'
              ),
            })}
          />
        </Form.Item>
      </FormLayoutGroup>

      <FormLayoutGroup mdColumns={2}>
        <Form.Item
          name="captiveSelfInsuredRetention"
          label={t(
            'claim.binderClaimsActions.programRIConsiderations.captiveSelfInsuredRetention'
          )}
        >
          <InputNumber
            size="large"
            className="w-full"
            placeholder={t('general.enter', {
              field: t(
                'claim.binderClaimsActions.programRIConsiderations.captiveSelfInsuredRetention'
              ),
            })}
          />
        </Form.Item>

        <Form.Item
          name="riSelfInsuredRetention"
          label={t(
            'claim.binderClaimsActions.programRIConsiderations.riSelfInsuredRetention'
          )}
        >
          <InputNumber
            size="large"
            className="w-full"
            placeholder={t('general.enter', {
              field: t(
                'claim.binderClaimsActions.programRIConsiderations.riSelfInsuredRetention'
              ),
            })}
          />
        </Form.Item>
      </FormLayoutGroup>

      <FormLayoutGroup mdColumns={2}>
        <Form.Item
          name="riCession"
          label={t(
            'claim.binderClaimsActions.programRIConsiderations.riCession'
          )}
        >
          <InputNumber
            size="large"
            className="w-full"
            suffix="%"
            placeholder={t('general.enter', {
              field: t(
                'claim.binderClaimsActions.programRIConsiderations.riCession'
              ),
            })}
          />
        </Form.Item>

        <Form.Item
          name="riCosts"
          label={t('claim.binderClaimsActions.programRIConsiderations.riCosts')}
        >
          <InputNumber
            size="large"
            className="w-full"
            placeholder={t('general.enter', {
              field: t(
                'claim.binderClaimsActions.programRIConsiderations.riCosts'
              ),
            })}
          />
        </Form.Item>
      </FormLayoutGroup>
    </FormSection>
  );
};

export default ProgramRIConsiderations;
